// extracted by mini-css-extract-plugin
export default {"content":"credit-time-tracker_content__4Tic5"};